module.exports = __webpack_public_path__ + "img/avatar.fd706bb1.png";